import { IMessageService } from "./IMessageService";
import { Message, areEqual } from "../model/Message";
import { SiteStoredSettings as localStorage } from "./LocalStorage";

export class LocalStorageMessageService implements IMessageService {
  handlers: (() => void)[] = [];
  constructor(messages: Message[]) {
    var savedMessages = localStorage.GetMessages();
    var updatedMessages = this.mergeMessages(savedMessages, messages);
    localStorage.SetMessages(updatedMessages);
  }
  mergeMessages(savedMessages: Message[], messages: Message[]) {
    var newMessages = messages.filter(m => savedMessages.find(s => areEqual(s, m)) === undefined)
    return savedMessages.concat(newMessages);
  }
  sendMessage(message: Message): void {
    var savedMessages = localStorage.GetMessages();
    var updatedMessages = this.mergeMessages(savedMessages, [message]);
    localStorage.SetMessages(updatedMessages);
    this.handlers.forEach(handler => handler());
  }
  dismissMessage(message: Message): void {
    localStorage.SetMessages(localStorage.GetMessages().map(m => 
      areEqual(m, message)
      ? new Message(m.message, m.detail, m.channel, m.timestamp, true)
      : m
    ));
    this.handlers.forEach(handler => handler());
  }
  getMessages(): Message[] {
    return localStorage.GetMessages().filter(message => !message.dismissed);
  }
  subscribe(handler: () => void): void {
    this.handlers = this.handlers.concat([handler]);
  }
}

export class SessionMessageService implements IMessageService {
  handlers: (() => void)[] = [];
  constructor(private messages: Message[]) {
  }
  sendMessage(message: Message): void {
    this.messages = this.messages.concat([message]);
    this.handlers.forEach(handler => handler());
  }
  dismissMessage(message: Message): void {
    this.messages = this.messages.filter(m => !areEqual(m, message));
    this.handlers.forEach(handler => handler());
  }
  getMessages(): Message[] {
    return this.messages;
  }
  subscribe(handler: () => void): void {
    this.handlers = this.handlers.concat([handler]);
  }
}

export class MessageService implements IMessageService {
  created = new Date();
  handlers: (() => void)[] = [];
  sessionMessageService: IMessageService;
  localStorageMessageService: IMessageService;
  constructor(staticMessages: Message[], sessionMessages: Message[]) {
    this.localStorageMessageService = new LocalStorageMessageService(staticMessages);
    this.sessionMessageService = new SessionMessageService(sessionMessages);
  }
  sendMessage(message: Message): void {
    console.log("created = " + this.created);
    console.log("created.getTime() = " + this.created.getTime());
    console.log("message = " + message.timestamp);
    console.log("message.getTime() = " + message.timestamp.getTime());
    if (message.timestamp.getTime() < this.created.getTime()) {
      console.log("sendMessage: local storage");
      console.log(message);
      this.localStorageMessageService.sendMessage(message);
    } else {
      console.log("sendMessage: session storage");
      console.log(message);
      this.sessionMessageService.sendMessage(message);
    }
    this.handlers.forEach(handler => handler());
  }
  dismissMessage(message: Message): void {
    this.sessionMessageService.dismissMessage(message);
    this.localStorageMessageService.dismissMessage(message);
    this.handlers.forEach(handler => handler());
  }
  getMessages(): Message[] {
    return this.localStorageMessageService.getMessages()
      .concat(this.sessionMessageService.getMessages());
  }
  subscribe(handler: () => void): void {
    this.handlers = this.handlers.concat([handler]);
  }
}